import React from 'react';
import { useWorkspaceContext } from '../../../context/workspaceContext.tsx';
import { ChatBotActionType } from '../../../@types/chatbot-action-type.ts';


const MessageParser = ({ children, actions }) => {
    const {  chatBotAction, currentWorkspaceObject , setChatBotAction} = useWorkspaceContext();
    
    React.useEffect(() => {
        if (chatBotAction && chatBotAction.actionType !== ChatBotActionType.UNKNOWN) {
            switch (chatBotAction.actionType) {
                case ChatBotActionType.CLEAR_HISTORY:
                    actions.clearMessages(0);
                    break;
                case ChatBotActionType.ADD_ESD:
                    actions.handleIncludeESD(chatBotAction.payload);
                    break;
                case ChatBotActionType.LLM_MODEL:
                    actions.handleLLMModel(chatBotAction.payload);
                    break;
                case ChatBotActionType.UPLOAD_FILE:
                    actions.handleUploadFile(chatBotAction.payload);
                    break;
                case ChatBotActionType.TRIGGER_REPLY:
                    actions.handleTriggerReply(chatBotAction.payload, currentWorkspaceObject);
                    break;
                default:
                    // eslint-disable-next-line no-console
                    console.log('MessageParser: chatBotAction', chatBotAction);

                    break;
            }
            setTimeout(() => {
                setChatBotAction({actionType: ChatBotActionType.UNKNOWN });
            }, 100);
            
        }
    }, [chatBotAction]);

    const parse = (message) => {
        const matches = message.toLowerCase().match(/clear history\s?(-?[0-9]*)$/);
        if (matches) {
            let count = matches[1] ? parseInt(matches[1]) : 0;
            actions.clearMessages(count);
            return;
        }
        actions.handleReply(message, currentWorkspaceObject);
    };

    return (
        <div>
            {React.Children.map(children, (child) => {
                return React.cloneElement(child, {
                    parse: parse,
                    actions,
                });
            })}
        </div>
    );
};

export default MessageParser;